import React from 'react';
import { ArrowRight, Building2, Globe } from 'lucide-react';

const SocialProof = () => {
  return (
    <section id="our-work" className="py-16 sm:py-20 px-4 sm:px-6 bg-gradient-to-b from-gray-900/30 to-black">
      <div className="max-w-5xl mx-auto">
        {/* Section Title */}
        <div className="text-center mb-10 sm:mb-14">
          <h2 className="text-4xl sm:text-5xl md:text-5xl font-display text-white mb-4 sm:mb-6 tracking-wide px-2">
            Our{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-gray-300">
              work
            </span>
          </h2>
          <p className="text-base sm:text-lg md:text-xl text-gray-300 max-w-3xl mx-auto leading-relaxed font-tech px-4">
            We build for our own businesses as well as our clients'. The quickest way to judge us is to go and look.
          </p>
        </div>

        {/* Two matching full-width cards */}
        <div className="space-y-6 sm:space-y-8">
          {/* BuildFlow */}
          <div className="p-6 sm:p-10 rounded-2xl bg-gradient-to-br from-purple-900/30 via-blue-900/20 to-gray-900/30 border border-gray-700/50 backdrop-blur-sm hover:border-purple-500/40 transition-all duration-300">
            <div className="flex flex-col sm:flex-row items-start gap-6">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex-shrink-0 bg-gradient-to-r from-purple-600/30 to-blue-500/30 rounded-2xl flex items-center justify-center">
                <Building2 className="w-8 h-8 sm:w-10 sm:h-10 text-gray-200" />
              </div>
              <div className="flex-grow">
                <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3 font-robotic">
                  BuildFlow — site management software
                </h3>
                <p className="text-base sm:text-lg text-gray-300 leading-relaxed font-tech mb-6">
                  Tasks, timesheets, materials, drawings and site photos in one place, exportable to CSV for the office. It's live, and the demo logs you straight in — no signup, no form. Built for construction, but it shows you the standard — we build software like this for any trade or business.
                </p>
                <a
                  href="https://buildflowconstructionapp.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 rounded-xl text-white font-bold text-base sm:text-lg tracking-wide transition-all duration-300 hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl font-robotic"
                >
                  See the live demo
                  <ArrowRight className="w-5 h-5 ml-2" />
                </a>
              </div>
            </div>
          </div>

          {/* Cornerstone Developments */}
          <div className="p-6 sm:p-10 rounded-2xl bg-gradient-to-br from-purple-900/30 via-blue-900/20 to-gray-900/30 border border-gray-700/50 backdrop-blur-sm hover:border-purple-500/40 transition-all duration-300">
            <div className="flex flex-col sm:flex-row items-start gap-6">
              <div className="w-16 h-16 sm:w-20 sm:h-20 flex-shrink-0 bg-gradient-to-r from-purple-600/30 to-blue-500/30 rounded-2xl flex items-center justify-center">
                <Globe className="w-8 h-8 sm:w-10 sm:h-10 text-gray-200" />
              </div>
              <div className="flex-grow">
                <h3 className="text-2xl sm:text-3xl font-bold text-white mb-3 font-robotic">
                  Cornerstone Developments — website
                </h3>
                <p className="text-base sm:text-lg text-gray-300 leading-relaxed font-tech mb-6">
                  The website for our own construction company. Services, a project gallery of real builds, and an enquiry form. West Yorkshire builders, twenty years in the trade.
                </p>
                <a
                  href="https://cornerstonesdevelopments.com"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="inline-flex items-center px-6 sm:px-8 py-3 sm:py-4 bg-gradient-to-r from-purple-600 to-blue-600 hover:from-purple-500 hover:to-blue-500 rounded-xl text-white font-bold text-base sm:text-lg tracking-wide transition-all duration-300 hover:scale-105 active:scale-95 shadow-lg hover:shadow-xl font-robotic"
                >
                  Visit the site
                  <ArrowRight className="w-5 h-5 ml-2" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default SocialProof;
